module.exports = __webpack_public_path__ + "img/yqlj.e70ef19d.png";